import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const publicApi = axios.create({ baseURL: `${BACKEND_URL}/api/public/online`, timeout: 15000 });

// Local snapshot cache (public, non-personal payloads only) keyed by slug / branch so the last menu can be shown
// instantly while a fresh copy is fetched. Never caches session/customer data; server stays authoritative at checkout.
const SNAP_PREFIX = "sc_online_snap_v1:";
export const readSnapshot = (key) => { try { const raw = localStorage.getItem(SNAP_PREFIX + key); return raw ? JSON.parse(raw) : null; } catch { return null; } };
export const writeSnapshot = (key, data) => { try { localStorage.setItem(SNAP_PREFIX + key, JSON.stringify(data)); } catch { /* quota / private mode */ } };
export const siteKey = (slug) => `site:${slug}`;
export const menuKey = (slug, branchId) => `menu:${slug}:${branchId}`;

// /site may have been started by index.js before React mounted (same URL) — consume that promise once.
const takePrefetchedSite = (slug) => {
  const p = window.__scSitePrefetch;
  if (!p || p.slug !== slug) return null;
  window.__scSitePrefetch = null;
  return p.promise;
};

export const fetchSite = (slug) => {
  const pre = takePrefetchedSite(slug);
  const req = pre ? pre.then((data) => data ?? publicApi.get(`/${encodeURIComponent(slug)}/site`).then((r) => r.data))
                  : publicApi.get(`/${encodeURIComponent(slug)}/site`).then((r) => r.data);
  return req.then((data) => { writeSnapshot(siteKey(slug), data); return data; });
};
export const fetchBranchMenu = (slug, branchId) =>
  publicApi.get(`/${encodeURIComponent(slug)}/branches/${encodeURIComponent(branchId)}/menu`).then((r) => { writeSnapshot(menuKey(slug, branchId), r.data); return r.data; });

export const money = (n) => `₹${Number(n || 0).toFixed(Number(n || 0) % 1 ? 2 : 0)}`;

export const haversineKm = (a, b) => {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const R = 6371, dLat = ((b.lat - a.lat) * Math.PI) / 180, dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
};
